import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';
import { NAV_BAR_WIDTH_COMPACT, NAV_BAR_WIDTH_EXPANDED } from '../../../constants/sizes';
import { navBackground } from '../NavBar/styles';

const { colors, common, typography } = THEME;

const AVATAR_SIZE = 32;
const TOGGLE_WIDTH = 20;
const TOGGLE_HEIGHT = 40;

// Fixed to the viewport so the tab continues the nav's gradient wherever it sits, at any window height.
const toggleBackground = (navWidth: number) => ({
	background: navBackground(`${navWidth}px`),
	backgroundAttachment: 'fixed' as const,
});

export const styleSheet = StyleSheet.create({
	avatar: {
		flexShrink: 0,
		height: AVATAR_SIZE,
		width: AVATAR_SIZE,
	},
	companyName: {
		...common.truncate,
		fontSize: typography.fontSizes.xs,
		opacity: 0.72,
	},
	footer: {
		alignItems: 'flex-start',
		display: 'flex',
		flexDirection: 'column',
		margin: SPACE[8],
		marginTop: 'auto',
		paddingTop: SPACE[16],
		position: 'relative',
		zIndex: 2,
	},
	menu: {
		minWidth: 200,
	},
	signpost: {
		gap: SPACE[8],
		height: 'auto',
		padding: SPACE[4],
	},
	signpostAvatar: {
		height: SPACE[32],
		width: SPACE[32],
	},
	signpostChevron: {
		display: 'flex',
	},
	toggle: {
		...toggleBackground(NAV_BAR_WIDTH_EXPANDED),
		border: 'none',
		borderRadius: `0 ${common.borderRadius}px ${common.borderRadius}px 0`,
		color: colors.primary.contrastText,
		height: TOGGLE_HEIGHT,
		minHeight: TOGGLE_HEIGHT,
		minWidth: TOGGLE_WIDTH,
		padding: 0,
		width: TOGGLE_WIDTH,
		':hover': {
			color: colors.primary.contrastText,
			filter: 'brightness(1.25)',
		},
		':is([aria-expanded="true"])': {
			color: colors.primary.contrastText,
		},
	},
	toggleCompact: toggleBackground(NAV_BAR_WIDTH_COMPACT),
	toggleIcon: {
		height: SPACE[16],
		width: SPACE[16],
	},
	tooltipTrigger: {
		width: '100%',
		':not(:first-child)': {
			marginTop: SPACE[8],
		},
	},
	userInfo: {
		display: 'flex',
		flexDirection: 'column',
		marginLeft: SPACE[12],
		minWidth: 0,
		textAlign: 'left',
	},
	userName: {
		...common.truncate,
		fontFamily: typography.fontFamilies.lexend,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.semibold,
	},
	userTrigger: {
		appearance: 'none',
		background: 'none',
		border: 'none',
		color: colors.primary.contrastText,
		cursor: 'pointer',
		font: 'inherit',
		height: 'auto',
		paddingBottom: SPACE[8],
		paddingLeft: SPACE[8],
		paddingTop: SPACE[8],
		// An open menu inserts a focus guard before the trigger, which would otherwise pick up the nav link's
		// not-first-child margin and shift the avatar.
		':not(:first-child)': {
			marginTop: 0,
		},
	},
	userTriggerCompact: {
		justifyContent: 'center',
		paddingLeft: SPACE[4],
		paddingRight: SPACE[4],
	},
});
